/**
 * Constants + testIDs for in-app announcements. See specs/in-app-announcements/spec.md.
 */

import type { SpacerSize } from '../types/announcements.types';

/** Known v1 block types (client renderer skips anything else). */
export const ANNOUNCEMENT_BLOCK_TYPES = {
  HEADING: 'heading',
  PARAGRAPH: 'paragraph',
  IMAGE: 'image',
  BUTTON: 'button',
  SPACER: 'spacer',
} as const;

/** Device-local key holding the JSON array of seen announcement ids. */
export const ANNOUNCEMENT_SEEN_STORAGE_KEY = 'seen_announcement_ids';

/** Cap on the stored seen set (prune oldest beyond this — the active feed is tiny). */
export const ANNOUNCEMENT_SEEN_MAX = 100;

/** Only evaluate/show announcements under this route prefix (mirrors the app shell gate). */
export const ANNOUNCEMENT_ROUTE_PREFIX = '/app';

/** React Query cache tuning — the server SWR cache is the real freshness authority. */
export const ANNOUNCEMENT_QUERY_STALE_MS = 5 * 60 * 1000; // 5 min
export const ANNOUNCEMENT_QUERY_GC_MS = 30 * 60 * 1000; // 30 min

/** Vertical space (px) rendered per spacer size. */
export const ANNOUNCEMENT_SPACER_SIZE_PX: Record<SpacerSize, number> = {
  sm: 8,
  md: 16,
  lg: 28,
};

export const ANNOUNCEMENT_TEST_IDS = {
  MODAL: 'announcement-modal',
  CARD: 'announcement-card',
  CLOSE: 'announcement-close',
  /** Per-block testID, e.g. `announcement-block-heading-0`. */
  block: (type: string, index: number): string => `announcement-block-${type}-${index}`,
} as const;
